import { supportLanguageList } from "constants/base";
import { SPOT_TACE_TAB } from "constants/spot";
import { SUPPORT_LAYOUT } from "constants/layout";
import { atom } from "recoil";
import { selectorWithoutCache as selector } from "util/RecoilWithoutCache";
import { LocaleSelector, LocaleState } from "./Base";
import { UserPreferenceSettingState } from "./User";
import { MixSpotAllTraceOrdersState } from "../spot/SpotTrading";
import {
  getCrossLiquidationPrice,
  getIsolatedLiquidationPrice,
  getRiskRate,
} from "../../util/Spot/spotLeverageHelper";
import {
  onAmount,
  onCost,
  onRoe,
  summaryCalMix,
} from "components/Spot/components/SpotHelper";
import Decimal from "decimal.js";
import LocalCache, { CacheKey } from "util/LocalCache";
// import { getIsolatedConfig } from 'api/spot/margin'
import { isSuccess } from "util/Common";
import { spotAllSymbol } from "api/ct";
import {
  createDefaultSpotConfig,
  createDefaultSpotTicker,
  createDefaultUserConfig,
} from "../spot/SpotCreaterHelper";
import { queryClient } from "@app/client/queryClient";
import { spotTicker as spotTickerQuery } from "api/ssr/ticker";
import { SpotCurrentTpslInfo } from "store/spot/types/ListTpsl";
import { MixMarginRiskRatioCoinListState } from "./../spot/SpotMarginBgbDeduction";
import { IsolatedInfoConfig } from "api/spot";
import { useParams } from "react-router-dom";
import { CallAuctionType } from "./SpotAuction";

export const notFindIndexPriceItemErrorText =
  "请检查ws, instType: mabl 或 channel: indexPrice。该币未找到指数价格: ";

//oco margin spot
export type SpotPlaceConfig = {
  propertyHighPlace: number; // 资产高精度
  propertyPlace: number; // 资产低精度
  pricePlace: number; // 价格精度
  delegatePricePlace: number; // 委托价格精度
  priceEndStep: number; // 委托价格步长
  volumePlace: number; // 数量精度  左
  quotePrecision?: number; // 数量精度  右
  minDelegateCount?: string; // 最小下单数量
  minTradeAmount?: string; // 最小交易数量
  minUsdtDelegateCount?: string; // 最小下单金额
  sellLimitPriceRatio: string; // 滑点限价
  buyLimitPriceRatio: string; // 滑点限价
  calculateMinTradeAmount: string;
  orderQuantity: string;
};

export type SpotConfig = {
  symbolClassify: number;
  baseSymbol: string; // 左币-大写
  pricedSymbol: string; // 计价币-右币-大写
  baseSymbolId: string; // 左币-id
  pricedSymbolId: string; // 计价币-右币-id
  symbolId: string; // 交易对唯一ID-大写-BTCUSDT_SPBL
  symbolCode: string; // 交易对code-撮合-大写-BTCUSDT
  oldSymbolCode: string; // 老的交易对code-大写-BTC_USDT
  displayName: string; // 显示用交易对名称-大写-BTC/USDT
  symbolDisplayName: string; // 顶替原来的displayName字段
  oldExchangeId: string; // 老交易对ID
  businessLine: string; // 业务线-大写-非数字表示-SPOT_BL
  businessType: string; // 业务类型-大写-SPOT_TYPE
  takerFeeRate: number; // taker手续费率-原始值-0.002-0.2%
  makerFeeRate: number; // maker手续费
  feeRateUpRatio: number; // 手续费上浮比例-原始值-0.1-10%
  openCostUpRatio: number; // 开仓成本上浮比例
  realCapitalRateRadio: number; // 不明
  betaShow: boolean; // 仅灰度展示
  margin?: {
    beta: boolean;
    crossLeverage: number; // 全仓倍数
    isolatedLeverage: number; // 逐仓倍数
    status: number;
    symbolId: string;
  };
  placeConfig: SpotPlaceConfig;
  displayRule: number; // 注意：该字段为一个十进制数值，表达含义需要转换为二进制。 如5(0101)，最低位表示（是否隐藏），其他位另作他用
  ownAmountBuy?: number;
  ownAmountSell?: number;
  isETF?: boolean;
  areaHide?: boolean; // 区域上币，是否隐藏，false表示不隐藏，true表示隐藏
  showFlag: number; // 标签支持，0:支持全部 1：支持现货，2:支持杠杆
  newLabelId: number; // 标签id
  symbolCodeDisplayName?: string; //路由用
  enableBidding?: boolean; //是否是集合竞价
  status?: number; // 状态，目前主要用于判断是否直接跳转btcusdt，目前是4的时候直接跳转
};

/**
 * tickersGroup频道推送的原始数据
 */
export type SpotTickerGroupInfo = {
  bA: string; // bestAsk
  bB: string; // bestBid
  bS: string; // baseSymbol
  bV: string; // baseVolume
  dP: string; // settlePrice
  dT: number; // downTime
  h: string; // high
  l: string; // low
  lI: number; // labeId
  o: string; // open
  oB: string; // before24Open
  oT: number; // ot
  oU: string; // openUtc
  p: string; // price
  pU: string; // toUsdt
  qS: string; // pricedSymbol
  qV: string; // quoteVolume
  s: number; // status
  sC: string; // symbolCode
  sCD: number; // scd
  stI: number; // sortId
  t: number; // ts
  uV: string; // usdtVolume
  /** indexPrice 指数价格*/
  iP: string;
  ca?: CallAuctionType;
};

/**
 * 币币改版，新的交易对详情结构
 */
export type SpotTicker = {
  before24Open: string;
  baseSymbol: string;
  baseVolume: string;
  quoteVolume: string; // 24h成交额(右币)
  change?: string; // 原始数据，需要手动乘以100,
  high: string;
  low: string;
  price: string;
  priceFixed: string;
  pricedSymbol: string;
  symbolCode: string; // 类似"BGBUSDT"
  toUsdt: string; // 可能是原来的toCNY字段
  sortId: number; //
  status: string | number; // 状态1-上架 2-开盘 3-停盘 4-下架
  ts: number; // 系统时间戳
  op: string; // 开盘价
  ot: number; // 开盘时间
  scd: number; // 是否显示倒计时：0-否 1-是
  labelId: number; // 显示额外标签
  labeId?: number; // 币对信息
  chgUTC?: number;
  downTime: number; // 下架时间
  settlePrice: number; // 下架结算价
  risefallstatue?: number; // 记录上一次价格的比较结果 1 涨 0 平 -1 跌
  bestAsk: string; // 最佳卖价
  bestBid: string; // 最佳买价
  ca?: CallAuctionType;
};

/**
 * 币币改版，余币情况
 */
export type NewSpotWalletInfo = {
  coinId: string;
  coinName: string;
  available: string;
  limitAvailable: string;
};
/**
 * 包含挂单吃单选项在内的用户设置
 */
export type SpotUserConfig = {
  agreedTime: number; // 同意使用的时间
  alertForLazyOp: number; // 挂单吃单是否提示（现在是两小时内不再提醒）
  alertForProfitControl: boolean; // 止盈止损是否提示
  switchForLazy: boolean; // 是否使用吃单挂单
  directionForLazy: number; // 挂单吃单的模式 1-开仓 2-平仓
  checkForMakerPO: boolean; // 挂单是否使用"只做Maker"模式
  checkForTakerIOC: boolean; // 吃单是否使用"IOC"
  checkForTakerFOK: boolean; // 吃单是否使用"FOK"
  checkForOpenMode: number; // 开仓数量模式 1-百分比 2-盘口
  openPercent: number; // 开仓数量百分比模式具体百分比
  checkForCloseMode: number; // 平仓数量模式 1-百分比 2-盘口
  closePercent: number; // 平仓数量百分比模式具体百分比
  isReady: boolean; // 配置是否就绪
};

// 成交记录：时间戳，价格，数量，方向
export type SpotTradeHistoryInfo = [string, string, string, string];

// 深度：价格，数量
export type SpotDepthInfo = [string, string];

export type SpotHistoryTpslInfo = {
  data: {
    cT: string;
    tT2: string;
    sDN: string;
    dT: number;
    tP: number;
    eP: number | null;
    oT: number;
    tT: string;
    dA: string;
    dC: number;
    s: number;
    mM: number;
    id: number;
    bS: number;
    cTP: string;
    tB: string;
    tQ: string;
    sId: string;
    type: string;
  };
  version: number;
  key: string;
};
export type SpotCurrentEntrustInfo = {
  fprize: string;
  ftype: number;
  id: string; //当前委托订单id
  accountId: string; //帐户id
  orderType: number; //订单类型:0限价 1市价
  orderTypeDesc: string; //描述
  baseToken: string; //左币
  quoteToken: string; //右币
  symbol: string; //交易对
  symbolId: string; //交易对id
  delegateType: number; //方向: 21-买， 22-卖
  delegateTypeDesc: string; //描述
  delegatePrice: string; //价格
  delegateCount: string; //数量
  delegateAmount: string; //金额
  timeInForce: number; //委托类型
  dealtCount: string; //已成交数量
  unDealtCount: string; //未成交数量
  status: number; //状态: 1."未撮合", 2."撮合已处理", 3."部分成交", 4."完全成交", 5."撤销", 6."拒单"
  statusDesc: string; //描述
  createTime: string; //创建时间戳
  updateTime: string; //更新时间戳
  enterPointSource: number; //订单进入点来源: 1 web；2 app；3 api；4 sys；
  averagePrice: string; //成交均价
  noDeductFee: string; //非抵扣费
  deductFee: string; //抵扣费
  version: string;
  averageDealPrice?: string | number; // 成交均价
  averageDealtPrice?: string | number; // 成交均价
  businessSource: number; // 类型
  profitPrice: string; // 止盈 触发价
  proExePrice: string; // 止盈 委托价  执行价
  lossPrice: string; // 止损 触发价
  lossExePrice: string; // 止损 委托价 执行价
};
export type SpotDealtRecord = {
  id: string; //成交id
  orderId: string; //委托单id
  accountId: string; //帐户id
  targetId: string; //对手record id
  targetAccountId: string; //对手帐户id
  baseToken: string; //左币
  quoteToken: string; //右币
  symbol: string; //交易对
  symbolId: string; //交易对id
  delegateType: number; //方向: 21-买， 22-卖
  delegateTypeDesc: string; //描述
  orderType: number; //订单类型:0限价 1市价
  orderTypeDesc: string; //描述
  dealtPrice: string; //价格
  dealtCount: string; //数量
  dealtAmount: string; //成交额
  fee: string; //手续费
  settleToken: string; //计费币种
  createTime: string; //创建时间戳
  updateTime: string; //更新时间戳
};

export type SpotCurrentPlanInfo = {
  id: string; //当前委托订单id
  accountId: string; //帐户id
  orderType: number; //订单类型:0限价 1市价
  baseToken: string; //左币
  quoteToken: string; //右币
  symbol: string; //交易对
  symbolId: string; //交易对id
  delegateType: number; //方向: 21-买， 22-卖
  delegateTypeDesc: string; //描述
  delegatePrice: string; //价格
  delegateCount: string; //数量
  delegateAmount: string; //金额
  unDealtCount: string; //未成交数量
  status: number; //状态: 1未执行 2执行成功 3执行失败 4取消
  statusDesc: string; //描述
  createTime: string; //创建时间戳
  updateTime: string; //更新时间戳
  enterPointSource: number; //订单进入点来源: 1 web；2 app；3 api；4 sys；
  triggerPrice: string; // 触发价格
  excutePrice: string;
  excuteCount: string; // 执行数量
  createTradePrice: string; // 创建时市价，用于比较大于等于号
  cancelReason: string; // 失败原因
  version: any;
  ptpp?: string; // 止盈
  pslp?: string; // 止损
  businessSource?: number; // 业务线类型
  presetTakeProfitPrice?: string; // 止盈触发价
  presetStopLossPrice?: string; // 止损触发价
};

// 新增仓位类型定义
export type SpotCurrentPosition = {
  net: 0; //净资产
  indexPrice: 0; //指数价格
  symbolCode: string; //所属币对，全仓情况下为N/A
  tokenId: string; //币种名
  tokenType: string; //币种类型，逐仓情况下左币为0，右币为1
};

// 档位定义 动态 后端根据specialLevel下发
export type SpotLeverageLevelInfo = {
  level: number; //档位
  validleverage: number; //有效杠杆
  maxLoanValuation: number; //计价最大可借 //右币
  maxLoanBase: number; //基础币最大可借 //左币
  marginRateInit: number; //初始保证金率
  marginRateMaintain: number; //维持保证金率
};

// ** 现货杠杆state类型定义 ******************begin
// 全仓资产
export type SpotCrossAccount = {
  borrowed: number; //已借资产
  cross: true; //是否全仓
  free: number; //可用资产
  interest: number; //已产生利息
  key: string; //唯一标识一条资产记录
  locked: number; //已锁定资产
  maintainRate: number; //维持保证金率
  net: number; //净资产
  symbolCode: string; //所属币对，全仓情况下为N/A
  tokenId: string; //币种名
  tokenType: string; //币种类型，逐仓情况下左币为0，右币为1
  total: number; //总资产
  version: number; //当前数据版本
};
// 逐仓资产
export type SpotIsolateAccount = {
  borrowed: number; //已借资产
  cross: false; //是否全仓
  free: number; //可用资产
  interest: number; //已产生利息
  key: string; //唯一标识一条资产记录
  locked: number; //已锁定资产
  maintainRate: number; //维持保证金率
  net: number; //净资产
  symbolCode: string; //所属币对，全仓情况下为N/A
  tokenId: string; //币种名
  tokenType: string; //币种类型，逐仓情况下左币为0，右币为1
  total: number; //总资产
  version: number; //当前数据版本
};

//全仓当前委托
export type SpotCrossCurrentEntrusts = {
  averageDealtPrice: number; //平均成交价
  baseTokenId: string; //base(左)币种;,如BTC
  createTime: string;
  cross: true;
  dealtAmount: number; //已成交总额;单位为右币种
  dealtCount: number; //已成交数量;单位为左币种
  delegateAmount: string;
  delegateCount: string; //委托数量;单位为左币种
  delegatePrice: string;
  delegateType: number; //订单类型;0:限价单;1:市价单
  id: string;
  orderType: string; //委托类型;21:买;22:卖
  quoteTokenId: string; //quote(右)币种;,如USDT
  updateTime: string;
  version: number;
  symbolId: string;
  unDealtCount: string;
};

//逐仓当前委托
export type SpotIsolateCurrentEntrusts = {
  averageDealtPrice: number; //平均成交价
  baseTokenId: string; //base(左)币种;,如BTC
  createTime: string;
  cross: true;
  dealtAmount: number; //已成交总额;单位为右币种
  dealtCount: number; //已成交数量;单位为左币种
  delegateAmount: string;
  delegateCount: string; //委托数量;单位为左币种
  delegatePrice: string;
  delegateType: number; //订单类型;0:限价单;1:市价单
  id: string;
  orderType: string; //委托类型;21:买;22:卖
  quoteTokenId: string; //quote(右)币种;,如USDT
  updateTime: string;
  version: number;
  symbolId: string;
  unDealtCount: string;
};

//全仓历史委托
export type SpotCrossHistoryEntrusts = {
  averageDealtPrice: number | string; // 成交均价
  baseTokenId: string;
  createTime: string;
  cross: true;
  dealtAmount: number;
  dealtCount: number;
  delegateAmount: number;
  delegateCount: number;
  delegatePrice: number;
  delegateType: string;
  id: string;
  orderStatus: string;
  orderType: string;
  quoteTokenId: string;
  updateTime: string;
  version: number;
  averageDealPrice?: string | number; // 成交均价
};

//逐仓历史委托
export type SpotIsolateHistoryEntrusts = {
  averageDealtPrice: number;
  baseTokenId: string;
  createTime: string;
  cross: boolean;
  dealtAmount: number;
  dealtCount: number;
  delegateAmount: number;
  delegateCount: number;
  delegatePrice: number;
  delegateType: string;
  id: string;
  orderStatus: string;
  orderType: string;
  quoteTokenId: string;
  updateTime: string;
  version: number;
};

//全仓成交明细
export type SpotCrossUserAccountDeal = {
  baseTokenId: string;
  createTime: string;
  cross: true;
  dealtAmount: number;
  dealtCount: number;
  dealtPrice: number;
  delegateType: string;
  fee: number;
  id: string;
  orderId: number;
  orderType: string;
  quoteTokenId: string;
  settleTokenId: string;
  symbolCode: string;
  takerMakerFlag: string;
  updateTime: string;
  version: number;
};
//逐仓成交明细
export type SpotIsolateUserAccountDeal = {
  baseTokenId: string;
  createTime: string;
  cross: false;
  dealtAmount: number;
  dealtCount: number;
  dealtPrice: number;
  delegateType: string;
  fee: number;
  id: string;
  orderId: number;
  orderType: string;
  quoteTokenId: string;
  settleTokenId: string;
  symbolCode: string;
  takerMakerFlag: string;
  updateTime: string;
  version: number;
};
//指数价格定义
export type SpotIndexPrice = {
  baseCoinId: number; //基础币种符号，如btc:1
  baseSymbol: string; //基础币种符号，如btc
  id: string;
  pricedCoinId: number; //计价币种符号，如usdt:2
  pricedSymbol: string; //计价币种符号，如usdt
  systemTime: number; //系统获取指数价格的时间
  tickerPrice: number; //指数价格
  version: number;
};
// oco当前委托  模式 杠杆独有 marginModelStr: , //杠杆买入类型。1:普通 2:自动借款。3:自动还款  ws数据
export type SpotCurrentOCOEntrustInfo = {
  id: any;
  version: any;
  strategyId: number;
  symbolId: string; //币对
  pairLeft: string; //左币
  pairRight: string; //右币
  createTime: string; //创建时间戳
  marginModelStr: string; //杠杆买入类型。1:普通 2:自动借款。3:自动还款
  ocoTypeStr: string; //oco类型 1-买入 2-卖出
  limitPrice: number; //限价
  triggerPrice: number; //触发价格
  delegatePrice: number; //价格
  delegateCount: number; //数量
  status: string; //策略状态 1:新建状态  2:待触发、3:触发中、4:下单中、 5:撤单中、 6:已撤单  7:执行失败.  8: 已执行
  statusDesc: string; //策略状态
  strategyReason: string; //策略终止原因
};

export type SpotDepthAskInfo = {
  prize: string;
  count: string;
  shortCount: string;
  order: number;
  sum: Decimal;
  weight: Decimal;
  isCurDelegate: boolean; // 是否是当前委托挂单
};
// 当前追踪委托
export type SpotCurrentTraceEntrustInfo = {
  data: SpotTracDataType;
  version: number;
  key: string;
};
export type SpotTracDataType = {
  cT: string; // 创建时间
  tT2: string; // 触发时间
  sDN: string; // 交易对
  dT: number; // 方向 1-买入 2-卖出
  tP: string; // 触发价
  eP: string; // 执行(委托)价格，市价为null
  oT: number; // 订单类型 1 市价 0 限价
  dA: string; // 委托金额
  dC: string; // 委托数量
  s: number; // 状态 ： 1-待执行 2-执行追踪中 3-已执行 4-执行失败 5-已撤单 6-下单中 7-撤单中
  bS: number; // 订单业务源 55 追踪委托市价单 56 追踪委托限价单
  cTP: string; // 当前价格
  tB: string; // 左币
  tQ: string; // 右币
  sId: string; // 币对
  pT: string; // 下单时间(回调幅度触发时间)
  rR: string; //追踪幅度
  type: number; // 类型 1 - 展示 ，其他-不展示
  id: number;
};

export function createDefaultSpotCurrentOCOEntrustInfo(): SpotCurrentOCOEntrustInfo {
  return {
    id: "",
    version: "",
    strategyId: 0,
    symbolId: "", //币对
    pairLeft: "", //左币
    pairRight: "", //右币
    createTime: "", //创建时间戳
    marginModelStr: "1", //杠杆买入类型。1:普通 2:自动借款。3:自动还款
    ocoTypeStr: "1", //oco类型 1-买入 2-卖出
    limitPrice: 0, //限价
    triggerPrice: 0, //触发价格
    delegatePrice: 0, //价格
    delegateCount: 0, //数量
    status: "1", //策略状态 1:新建状态  2:待触发、3:触发中、4:下单中、 5:撤单中、 6:已撤单  7:执行失败.  8: 已执行
    statusDesc: "", //策略状态
    strategyReason: "", //策略终止原因
  };
}

export function createDefaultSpotPlaceConfig(): SpotPlaceConfig {
  return {
    priceEndStep: 1,
    pricePlace: 2,
    propertyHighPlace: 8,
    propertyPlace: 4,
    volumePlace: 4,
    delegatePricePlace: 4,
  };
}

/**
 * displayRule 字段位的说明
 * (spotConfig.displayRule & SpotDisplayRule.HIDE) === SpotDisplayRule.Hide ? `hide` : `don't hide`
 * @type {{HIDE: number}}
 */
export enum SpotDisplayRule {
  HIDE = 1,
}

//看不懂！！！必要性是什么
export function matchSpotDisplayRule(
  value: SpotDisplayRule,
  rule: SpotDisplayRule
) {
  return value & Number(rule === rule);
}

//主站的全局state部分
/**
 * leftCoinList 信息
 */
export const MixSpotLeftCoinListState = atom<[]>({
  key: "mix-spot-left-coin-list-state",
  default: [],
});

/**
 * rightCoinList 信息
 */
export const MixSpotRightCoinListState = atom<[]>({
  key: "mix-spot-right-coin-list-state",
  default: [],
});

// 所有币 atom
export const MixSpotAllCoinListState = atom({
  key: "mix-spot-all-coin-list-state",
  default: [],
});

//现货部分
/**
 * 当前Symbol信息
 */
export const MixSpotSymbolState = atom<string>({
  key: "mix-spot-symbol-state",
  default: "",
});

/**
 * symbolId信息
 */
export const MixSpotSymbolIdState = atom<string>({
  key: "mix-spot-symbolId-state",
  default: "",
});

interface IMixSpotDepthALLPriceState {
  prize: "";
  count: "";
  total: "";
  totalTradeValue: "";
  type: "";
}

interface IMixSpotDepthSellPriceState {
  prize: "";
  count: "";
  total: "";
  totalTradeValue: "";
}

/**
 * DepthPrice 对象 信息
 */
// 买盘和卖盘合并的  价格 用于下单赋值 价格
export const MixSpotDepthPriceState = atom({
  key: "mix-spot-depth-price-state",
  default: { prize: "" },
});
// 买盘和卖盘合并
export const MixSpotDepthAllPriceState = atom<IMixSpotDepthALLPriceState>({
  key: "mix-spot-depth-all-price-state",
  default: { prize: "", count: "", total: "", totalTradeValue: "", type: "" },
});
// 买盘 数量 交易额状态
export const MixSpotDepthBuyPriceState = atom<IMixSpotDepthSellPriceState>({
  key: "mix-spot-depth-buy-price-state",
  default: { prize: "", count: "", total: "", totalTradeValue: "" },
});
// 卖盘 数量 交易额状态
export const MixSpotDepthSellPriceState = atom<IMixSpotDepthSellPriceState>({
  key: "mix-spot-depth-sell-price-state",
  default: { prize: "", count: "", total: "", totalTradeValue: "" },
});

/**
 * layout 信息
 */
export const MixSpotLayoutState = atom<SUPPORT_LAYOUT>({
  key: "mix-spot-layout-state",
  default: LocalCache.get(CacheKey.SPOT_LAYOUT) || SUPPORT_LAYOUT.right, //SUPPORT_LAYOUT.right
});

/**
 * bestAskPrice 信息
 */
export const MixSpotBestAskPriceState = atom<string>({
  key: "mix-spot-best-ask-price-state",
  default: "",
});

/**
 * bestBidPrice 信息
 */
export const MixSpotBestBidPriceState = atom<string>({
  key: "mix-spot-best-bid-price-state",
  default: "",
});

/**
 * 中心布局选择 手动 自动借款 自动还款 自动借还
 */
export const MixSpotBorrowRepayTypeState = atom<number>({
  key: "mix-spot-borrow-repay-type-state",
  default: 3,
});

/**
 * tabType 信息  spot 现货 cross 全仓 isolated 逐仓
 */
type IMixSpotTabTypeState = "spot" | "isolated" | "cross" | "";
export const MixSpotTabTypeState = atom<IMixSpotTabTypeState>({
  key: "mix-spot-tab-type-state",
  default: "",
});

/**
 * isGuideShow 信息
 */
export const MixSpotIsGuideShowState = atom<number>({
  key: "mix-spot-is-guide-show-state",
  default: 5,
});

/**
 * leftCoinCount 信息
 */
export const MixSpotLeftCoinCountSelector = selector({
  key: "mix-spot-left-coin-coint-selector",
  get: ({ get }) => {
    const { baseSymbol } = get(MixSpotConfigState);
    const wallets = get(MixSpotWalletsUseState);
    if (!baseSymbol) return Number(0).toFixed(8);
    return wallets.get(baseSymbol.toUpperCase()) || Number(0).toFixed(8);
  },
});

/**
 * rightCoinCount 信息
 */
export const MixSpotRightCoinCountSelector = selector({
  key: "mix-spot-right-coin-coint-selector",
  get: ({ get }) => {
    const { pricedSymbol } = get(MixSpotConfigState);
    const wallets = get(MixSpotWalletsUseState);
    return wallets.get(pricedSymbol.toUpperCase()) || Number(0).toFixed(8);
  },
});

/**
 * marketDetailReady 信息
 */
export const MixSpotMarketDetailReadyState = atom<boolean>({
  key: "mix-spot-market-detail-ready-state",
  default: false,
});

/**
 * automaticBorrowing 信息
 */
export const MixSpotAutomaticBorrowingState = atom<boolean>({
  key: "mix-spot-automatic-borrowing-state",
  default: false,
});

/**
 * 杠杆 全仓 总负债金额
 */
export const MixSpotLiabilities = atom<number>({
  key: "mix-spot-Liabilities",
  default: 0,
});

/**
 * 委托类型 信息 //当前 历史 明细
 */
export const MixSpotCurEntrustTypeState = atom<number>({
  key: "mix-spot-current-entrust-type-state",
  default: 0,
});

/**
 * 当前计划列表当前选择 信息
 */
export const MixSpotCurrentPlansSwitchState = atom<SpotCurrentPlanInfo[]>({
  key: "mix-spot-current-plans-state-switch",
  default: [],
});

/**
 * 当前计划列表 信息
 */
export const MixSpotCurrentPlansState = atom<SpotCurrentPlanInfo[]>({
  key: "mix-spot-current-plans-state",
  default: [],
});

/**
 * historyPlans 信息
 */
export const MixSpotHistoryPlansState = atom<SpotCurrentPlanInfo[]>({
  key: "mix-spot-history-plans-state",
  default: [],
});
// 追踪委托历史
export const MixSpotHistoryTracksState = atom<SpotCurrentTraceEntrustInfo[]>({
  key: "mix-spot-history-track-state",
  default: [],
});

/**
 * currentEntrust 当前委托现货 信息
 */
export const MixSpotCurrentEntrustState = atom<SpotCurrentEntrustInfo[]>({
  key: "mix-spot-current-entrust-state",
  default: [],
});
/**
 * currentTspl 止盈止损
 */
export const MixSpotCurrentTpslState = atom<SpotCurrentTpslInfo[]>({
  key: "mix-spot-current-tpsl-state",
  default: [],
});

/*
 * 杠杆全仓当前 止盈止损
 */
export const MixCrossCurrentTpslState = atom<Array<SpotHistoryTpslInfo[]>>({
  key: "mix-Cross-current-tpsl-state",
  default: [],
});

/*
 * 杠杆逐仓当前 止盈止损
 */
export const MixIsolatedCurrentTpslState = atom<Array<SpotHistoryTpslInfo[]>>({
  key: "mix-isolated-current-tpsl-state",
  default: [],
});
/*
 * 杠杆逐仓当前 止盈止损
 */
export const MixIsolatedCurrentTpslStateSwitch = atom({
  key: "mix-isolated-current-entrust-selector-symbol-switch",
  default: [],
});
/**
 * currentEntrust 当前币对 信息 普通 杠杆（全.逐）
 */
export const MixSpotCurrentEntrustSymbolSwitch = atom({
  key: "mix-spot-current-entrust-selector-symbol-switch",
  default: [],
});

export const MixSpotCurrentTpslSymbolSwitch = atom({
  key: "mix-spot-current-tpsl-selector-symbol-switch",
  default: [],
});

/**
 * currentEntrust Selector 信息 普通 杠杆（全.逐）
 */
export const MixSpotCurrentEntrustSelector = selector<
  Array<
    | SpotCurrentEntrustInfo
    | SpotCrossCurrentEntrusts
    | SpotIsolateCurrentEntrusts
  >
>({
  key: "mix-spot-current-entrust-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "spot") return get(MixSpotCurrentEntrustState);
    if (tabType === "cross") return get(MixSpotCrossCurrentEntrustsState);
    if (tabType === "isolated") return get(MixSpotIsolatedCurrentEntrustsState);
    return [];
  },
});

/**
 * fentrustlogs 信息 普通 杠杆（全.逐）
 * MixSpotCrossUserAccountDealState
 * MixSpotIsolatedUserAccountDealState
 */
export const MixSpotFentrustlogsSelector = selector({
  key: "mix-spot-fentrust-logs-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "spot") return get(MixSpotFentrustlogsState);
    if (tabType === "cross") return get(MixSpotCrossUserAccountDealState);
    if (tabType === "isolated") return get(MixSpotIsolatedUserAccountDealState);
    return [];
  },
});

/**
 * fentrustlogs 信息
 */
export const MixSpotFentrustlogsState = atom<SpotDealtRecord[]>({
  key: "mix-spot-fentrust-logs-state",
  default: [],
});

/**
 * historyEntrust 信息
 */
export const MixSpotHistoryEntrustState = atom<SpotCurrentEntrustInfo[]>({
  key: "mix-spot-history-entrust-state",
  default: [],
});
/**
 * historyTpsl 信息
 */
export const MixSpotHistoryTpslState = atom<SpotHistoryTpslInfo[]>({
  key: "mix-spot-history-tpsl-state",
  default: [],
});
/**
 * 杠杆 全仓 historyTpsl 信息
 */
export const MixCrossHistoryTpslState = atom<SpotHistoryTpslInfo[]>({
  key: "mix-corss-history-tpsl-state",
  default: [],
});
/**
 * 杠杆 逐仓 historyTpsl 信息
 */
export const MixIsolatedHistoryTpslState = atom<SpotHistoryTpslInfo[]>({
  key: "mix-isolated-history-tpsl-state",
  default: [],
});
/**
 * allTicker 信息
 */
export const MixSpotAllTickerState = atom({
  key: "mix-spot-all-ticker-state",
  default: [],
});

/**
 * last allTicker price rise fall
 */
export const MixSpotAllTickerRiseFallState = atom({
  key: "mix-spot-all-ticker-rise-fall-state",
  default: [],
});

/**
 * wallets 信息
 */
export const MixSpotAllTickerSelector = selector({
  key: "mix-spot-all-ticker-state-selector",
  get: ({ get }) => {
    return get(MixSpotAllTickerState);
  },
  set: ({ get, set }, data: any[]) => {
    let riseFall = get(MixSpotAllTickerRiseFallState);
    const SpotConfigList = get(MixSpotConfigListState);
    const plots = data.map((item) => {
      let sfItem = riseFall.find((rsm) => rsm.symbolCode === item.symbolCode);
      let status = 0;
      if (!sfItem || sfItem.price === item.price) {
        status = 0;
      } else if (Number(sfItem.price) < Number(item.price)) {
        status = 1;
      } else {
        status = -1;
      }

      // 这个字段 主要用于 最新成交价 带入 下单的价格input里面【解决ticker精度跟配置精度不同的问题】
      const SpotConfig = SpotConfigList.find(
        (scItem) =>
          item.baseSymbol.toUpperCase() === scItem?.baseSymbol?.toUpperCase() &&
          item.pricedSymbol.toUpperCase() ===
            scItem?.pricedSymbol?.toUpperCase()
      );
      let numArr = item?.price?.split(".") || ["", ""];
      let originLen = numArr[1]?.length || 0;
      let configLength =
        SpotConfig?.placeConfig?.delegatePricePlace || originLen;

      let priceFixed = item.price;
      if (configLength !== originLen) {
        priceFixed = new Decimal(item.price ?? 0).toFixed(configLength ?? 4);
      }

      return {
        ...item,
        priceFixed,
        risefallstatue: status,
      };
    });
    set(MixSpotAllTickerState, plots);
    const simple = data.map((item) => {
      return {
        symbolCode: item.symbolCode,
        price: item.price,
      };
    });
    set(MixSpotAllTickerRiseFallState, simple);
  },
});

/**
 * spot userConfig 信息
 */
export const MixSpotUserConfigState = atom<SpotUserConfig>({
  key: "mix-spot-user-config-state",
  default: createDefaultUserConfig(),
});

/**
 * wallets 信息
 */
export const MixSpotWalletsUseState = atom({
  key: "mix-spot-wallets-use-state",
  default: new Map<string, string>(),
});

/**
 * wallets base 信息  没地方使用
 */
export const MixSpotWalletsState = atom<NewSpotWalletInfo[]>({
  key: "mix-spot-wallets-state",
  default: [],
});
/**
 * wallets 信息 只ws设置调用
 */
export const MixSpotWalletsSelector = selector({
  key: "mix-spot-wallets-selector",
  // 废弃 没地方使用
  get: ({ get }) => {
    const wallets = get(MixSpotWalletsState);
    return wallets;
  },
  // 仅ws调用
  set: ({ get, set }, data: NewSpotWalletInfo[]) => {
    let walletsMap = get(MixSpotWalletsUseState);
    let updateWallets = data.reduce((m, w) => {
      let newAvailbale = new Decimal(w?.available || 0)
        .sub(new Decimal(w?.limitAvailable || 0))
        .toString();
      m.set(w.coinName.toUpperCase(), newAvailbale); //w.available)
      return m;
      // 为了能够正确更新，可能存在性能问题
    }, new Map<string, string>(walletsMap));
    set(MixSpotWalletsUseState, updateWallets);
  },
});

/**
 * spotConfig 信息 记录当前symbolId的 spotConfig
 */
export const MixSpotConfigState = atom<SpotConfig>({
  key: "mix-spot-config-state",
  default: createDefaultSpotConfig(),
});

// /**
//  * allMarginCoinList 信息  全仓币种信息列表 （ 最大可借 vips 利息 转入 信息等）
//  */
export const MixSpotCrossCoinConfigList = atom({
  key: "mix-spot-all-margin-coin-list-state",
  default: [],
});

/**
 * spotConfigList 信息
 */
export const MixSpotConfigListState = atom<SpotConfig[]>({
  key: "mix-spot-config-list-state",
  default: [],
});

/**
 * tradeHistory 信息 貌似没用到？
 */
export const MixSpotTradeHistoryState = atom({
  key: "mix-spot-trade-history-state",
  default: [],
});

//杠杆

/**
 * spotCrossAccounts 信息
 */
export const MixSpotCrossAccountsState = atom<SpotCrossAccount[]>({
  key: "mix-spot-cross-accounts-state",
  default: [],
});

/**
 * spotIsolateAccounts 信息
 */
export const MixSpotIsolatedAccountsState = atom({
  key: "mix-spot-isolated-accounts-state",
  default: [],
});

/**
 * spotCrossAccounts + debtNum 信息
 */
export const MixSpotCrossAccountsDebtSelector = selector({
  key: "mix-spot-cross-accounts-debt-selector",
  get: ({ get }) => {
    const crossAccounts = get(MixSpotCrossAccountsState);
    const spotIndexPrices = get(MixSpotIndexPricesState);
    const allTicker = get(MixSpotAllTickerState);
    let indexPrice = 0;
    let indexPriceText = "";
    let borrowedUvalue = "0";
    let borrowedUvalueText = "0";
    let totalUvalue = "0";
    let totalUvalueText = "0";
    return crossAccounts.map((item) => {
      // 找指数价
      let find = spotIndexPrices.find(
        (indexPricesItem) =>
          indexPricesItem?.baseSymbol?.toUpperCase() ===
          item?.tokenId?.toUpperCase()
      );
      let tickerFind = allTicker?.find(
        (tickerGroup) =>
          tickerGroup?.baseSymbol?.toUpperCase() === item.tokenId.toUpperCase()
      );
      indexPrice =
        item.tokenId.toUpperCase() == "USDT"
          ? 1
          : find?.tickerPrice || tickerFind?.price || 0;
      if (indexPrice) {
        indexPriceText = String(indexPrice) || "";
        // 总额估值 计算和展示
        borrowedUvalue = new Decimal(item.borrowed || 0)
          .mul(indexPrice || 0)
          .toFixed(8, Decimal.ROUND_DOWN)
          .toString();
        borrowedUvalueText = borrowedUvalue;
        // 已借估值 计算和展示
        totalUvalue = new Decimal(item.total || 0)
          .mul(indexPrice || 0)
          .toFixed(8, Decimal.ROUND_DOWN)
          .toString();
        totalUvalueText = totalUvalue;
      } else {
        indexPriceText = "- -";
        borrowedUvalue = "0";
        borrowedUvalueText = "- -";
        totalUvalue = "0";
        totalUvalueText = "- -";
        console.warn(notFindIndexPriceItemErrorText, item.tokenId);
      }
      return {
        ...item,
        // 负债值
        indexPrice,
        indexPriceText,
        debtNum: new Decimal(item.borrowed || 0)
          .mul(item.interest || 0)
          .toNumber()
          .toFixed(8),
        // 借款 U本位价值 借款*指数价
        borrowedUvalue,
        borrowedUvalueText,
        // 总额 U本位价值 总额*指数价
        totalUvalue,
        totalUvalueText,
      };
    });
  },
});

/**
 * spotIsolateAccounts + debtNum 信息   暂无使用
 */
export const MixSpotIsolatedAccountsDebtSelector = selector({
  key: "mix-spot-isolated-accounts-debt-selector",
  get: ({ get }) => {
    const isolatedAccounts = get(MixSpotIsolatedAccountsState);
    return isolatedAccounts.map((item) => {
      return {
        ...item,
        // 负债值
        debtNum: new Decimal(item.borrowed || 0)
          .add(item.interest || 0)
          .toNumber()
          .toFixed(8),
      };
    });
  },
});

/**
 * currentCrossPositions 全仓仓位信息
 */
export const MixSpotCurrentCrossPositionsSelector = selector({
  key: "mix-spot-current-cross-positions-selector",
  get: ({ get }) => {
    const spotIndexPrices = get(MixSpotIndexPricesState);
    const spotCrossAccounts = get(MixSpotCrossAccountsState);
    const spotConfigList = get(MixSpotConfigListState);
    const allTicker = get(MixSpotAllTickerState);
    let indexPrice = 0;
    let indexPriceText = "";
    let aboutNetVal = "0";
    let aboutNetValText = "";
    let forceClosePriceText = "";
    //强评价是0 就应该不显示 或者显示永不爆仓 跟usdt保持一致
    return spotCrossAccounts.map((position) => {
      let forceClosePrice = getCrossLiquidationPrice(
        position.tokenId,
        spotCrossAccounts,
        spotIndexPrices,
        spotConfigList,
        allTicker
      );
      let find = spotIndexPrices.find(
        (item) => item.baseSymbol === position.tokenId
      );
      let tickerFind = allTicker?.find(
        (tickerGroup) =>
          tickerGroup?.baseSymbol?.toUpperCase() ===
          position?.tokenId?.toUpperCase()
      );
      indexPrice =
        position?.tokenId.toUpperCase() == "USDT"
          ? 1
          : find?.tickerPrice || tickerFind?.price || 0;
      if (indexPrice) {
        indexPriceText = String(indexPrice) || "";
        aboutNetVal = new Decimal(position.net || 0)
          .times(indexPrice || 0)
          .toFixed(8, Decimal.ROUND_DOWN);
        aboutNetValText = aboutNetVal;
        forceClosePriceText = forceClosePrice;
      } else {
        indexPriceText = "- -";
        aboutNetVal = "0";
        aboutNetValText = "- -";
        forceClosePriceText = "- -";
        console.warn(notFindIndexPriceItemErrorText, position.tokenId);
      }

      // 仓位  大约的价值
      // let aboutNetVal = new Decimal(position.net || 0).times(indexPrice || 0).toFixed(8, Decimal.ROUND_DOWN)
      return {
        ...position,
        forceClosePrice,
        forceClosePriceText,
        indexPrice,
        indexPriceText,
        aboutNetVal,
        aboutNetValText,
      };
    });
  },
});

/**
 * spotIsolateAccounts 下单列表页信息 仓位   暂无使用
 */
export const MixSpotIsolatedPositionsSelector = selector({
  key: "mix-spot-isolated-positions-selector",
  get: ({ get }) => {
    const spotIndexPrices = get(MixSpotIndexPricesState);
    const spotIsolateAccounts = get(MixSpotIsolatedAccountsState);
    const spotConfigList = get(MixSpotConfigListState);
    const allTicker = get(MixSpotAllTickerState);
    //强评价是0 就应该不显示 或者显示永不爆仓 跟usdt保持一致
    let indexPrice = 0;
    return spotIsolateAccounts.map((position) => {
      let forceClosePrice = getIsolatedLiquidationPrice(
        position.tokenId,
        spotIsolateAccounts,
        spotIndexPrices,
        spotConfigList,
        allTicker
      );
      let find = spotIndexPrices.find(
        (item) => item.baseSymbol === position.tokenId
      );
      indexPrice = 1;
      if (find) {
        indexPrice = find.tickerPrice;
      } else {
        console.warn(notFindIndexPriceItemErrorText, position.tokenId);
      }
      // 仓位  大约的价值
      let aboutNetVal = new Decimal(position.net || 0)
        .times(indexPrice || 0)
        .toFixed(8);
      return {
        ...position,
        forceClosePrice,
        indexPrice,
        aboutNetVal,
      };
    });
  },
});

/**
 * spotIsolateAccounts 下单列表页信息 仓位 + 资产 新资产数据
 */
export const MixSpotIsolatedAssetsPositionsSelector = selector({
  key: "mix-spot-isolated-assets-positions-selector",
  get: ({ get }) => {
    const spotIndexPrices = get(MixSpotIndexPricesState);
    const spotIsolateAccounts = get(MixSpotIsolatedAccountsState);
    const spotConfigList = get(MixSpotConfigListState);
    const allTicker = get(MixSpotAllTickerState);
    let finalMap = {};
    let indexPrice = 0;
    let indexPriceText = "";
    let borrowedUvalue = "0";
    let borrowedUvalueText = "0";
    let totalUvalue = "0";
    let totalUvalueText = "0";
    let forceClosePriceText = "0";
    spotIsolateAccounts.forEach((item) => {
      if (!finalMap[item.symbolCode]) {
        finalMap[item.symbolCode] = [];
      }
      // 预估强平
      let forceClosePrice = getIsolatedLiquidationPrice(
        item.tokenId,
        spotIsolateAccounts,
        spotIndexPrices,
        spotConfigList,
        allTicker
      );

      let find = spotIndexPrices.find(
        (idxPriceItem) => idxPriceItem.baseSymbol === item.tokenId
      );
      let tickerFind = allTicker?.find(
        (tickerGroup) =>
          tickerGroup?.baseSymbol?.toUpperCase() ===
          item?.tokenId?.toUpperCase()
      );
      indexPrice =
        item?.tokenId?.toUpperCase() == "USDT"
          ? 1
          : find?.tickerPrice || tickerFind?.price || 0;
      // 仓位  大约的价值
      let aboutNetVal = new Decimal(item.net || 0)
        .times(indexPrice || 0)
        .toFixed(8);
      let aboutNetValText = "0";
      if (indexPrice) {
        indexPriceText = String(indexPrice) || "";
        // 总额估值 计算和展示
        borrowedUvalue = new Decimal(item.borrowed || 0)
          .mul(indexPrice || 0)
          .toFixed(8, Decimal.ROUND_DOWN)
          .toString();
        borrowedUvalueText = borrowedUvalue;
        // 已借估值 计算和展示
        (totalUvalue = new Decimal(item.total || 0)
          .mul(indexPrice || 0)
          .toFixed(8, Decimal.ROUND_DOWN)
          .toString()),
          (totalUvalueText = totalUvalue);
        forceClosePriceText = forceClosePrice;
        aboutNetValText = aboutNetVal;
      } else {
        indexPriceText = "- -";
        borrowedUvalue = "0";
        borrowedUvalueText = "- -";
        totalUvalue = "0";
        totalUvalueText = "- -";
        forceClosePriceText = "- -";
        aboutNetValText = "- -";
        console.warn(notFindIndexPriceItemErrorText, item.tokenId);
      }

      finalMap[item.symbolCode].push({
        ...item,
        forceClosePrice,
        forceClosePriceText,
        indexPrice,
        indexPriceText,
        aboutNetVal,
        aboutNetValText,
        // 负债值
        debtNum: new Decimal(item.borrowed || 0)
          .add(item.interest || 0)
          .toNumber()
          .toFixed(8),
        // 借款 U本位价值 借款*指数价
        borrowedUvalue,
        borrowedUvalueText,
        // 总额 U本位价值 总额*指数价
        totalUvalue,
        totalUvalueText,
      });
      finalMap[item.symbolCode].sort((a, b) => a.tokenType - b.tokenType);
    });
    return finalMap;
  },
});

//

/**
 * cross leftCoinCount 信息
 */
export const MixSpotCrossLeftCoinCountSelector = selector({
  key: "mix-spot-cross-left-coin-coint-selector",
  get: ({ get }) => {
    const { baseSymbol } = get(MixSpotConfigState);
    const crossAccounts = get(MixSpotCrossAccountsState);
    let findRet = crossAccounts.find(
      (item) => item.tokenId.toUpperCase() === baseSymbol.toUpperCase()
    );
    return findRet ? findRet.free : Number(0).toFixed(8);
  },
});

/**
 * cross rightCoinCount 信息
 */
export const MixSpotCrossRightCoinCountSelector = selector({
  key: "mix-spot-cross-right-coin-coint-selector",
  get: ({ get }) => {
    const crossAccounts = get(MixSpotCrossAccountsState);
    const { pricedSymbol } = get(MixSpotConfigState);
    let findRet = crossAccounts.find(
      (item) => item.tokenId.toUpperCase() === pricedSymbol.toUpperCase()
    );
    return findRet ? findRet.free : Number(0).toFixed(8);
  },
});

/**
 * isolated leftCoinCount 信息
 */
export const MixSpotIsolatedLeftCoinCountSelector = selector({
  key: "mix-spot-isolated-left-coin-coint-selector",
  get: ({ get }) => {
    const { baseSymbol, symbolId } = get(MixSpotConfigState);
    const isolatedAccounts = get(MixSpotIsolatedAccountsState);
    let findRet = isolatedAccounts.find(
      (item) =>
        symbolId.toUpperCase().includes(item.symbolCode.toUpperCase()) &&
        item.tokenId.toUpperCase() === baseSymbol.toUpperCase()
    );
    return findRet ? findRet.free : Number(0).toFixed(8);
  },
});

/**
 * isolated rightCoinCount 信息
 */
export const MixSpotIsolatedRightCoinCountSelector = selector({
  key: "mix-spot-isolated-right-coin-coint-selector",
  get: ({ get }) => {
    const { pricedSymbol, symbolId } = get(MixSpotConfigState);
    const isolatedAccounts = get(MixSpotIsolatedAccountsState);
    let findRet = isolatedAccounts.find(
      (item) =>
        symbolId.toUpperCase().includes(item.symbolCode.toUpperCase()) &&
        item.tokenId.toUpperCase() === pricedSymbol.toUpperCase()
    );
    return findRet ? findRet.free : Number(0).toFixed(8);
  },
});

/**
 * oco leftCoinCount 信息
 */
export const MixSpotOCOLeftCoinCountSelector = selector({
  key: "mix-spot-oco-left-coin-coint-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossLeftCoinCountSelector);
    return get(MixSpotIsolatedLeftCoinCountSelector);
  },
});

/**
 * oco  rightCoinCount 信息
 */
export const MixSpotOCORightCoinCountSelector = selector({
  key: "mix-spot-oco-right-coin-coint-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossRightCoinCountSelector);
    return get(MixSpotIsolatedRightCoinCountSelector);
  },
});

/**
 * 全仓 逐仓 切换获取 rightCoinCount 信息
 */
export const MixSpotIsolatedOrCrossRightCoinCountSelector = selector({
  key: "mix-spot-isolated-cross-right-coin-coint-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossRightCoinCountSelector);
    return get(MixSpotIsolatedRightCoinCountSelector);
  },
});

/**
 * 全仓 逐仓 切换获取 LeftCoinCount 信息
 */
export const MixSpotIsolatedOrCrossLeftCoinCountSelector = selector({
  key: "mix-spot-isolated-cross-left-coin-coint-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossLeftCoinCountSelector);
    return get(MixSpotIsolatedLeftCoinCountSelector);
  },
});

/**
 * oco cross 或 Isolate    account 信息
 */
export const MixSpotOCOAccountSelector = selector({
  key: "mix-spot-oco-account-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossAccountsState);
    return get(MixSpotIsolatedAccountsState);
  },
});

/**
 * 全仓、逐仓     cross 或 Isolate    account 信息
 */
export const MixSpotIsolatedOrCrossAccountSelector = selector({
  key: "mix-spot-isolated-cross-account-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "cross") return get(MixSpotCrossAccountsState);
    return get(MixSpotIsolatedAccountsState);
  },
});

/**
 * spotCrossCurrentEntrusts 信息
 */
export const MixSpotCrossCurrentEntrustsState = atom<
  SpotCrossCurrentEntrusts[]
>({
  key: "mix-spot-cross-current-entrusts-state",
  default: [],
});

/**
 * spotIsolatedCurrentEntrusts 信息
 */
export const MixSpotIsolatedCurrentEntrustsState = atom({
  key: "mix-spot-isolate-current-entrusts-state",
  default: [],
});

/**
 * spotCrossHistoryEntrusts 信息 全仓 历史委托  updateSpotCrossHistoryEntrustsList
 */
export const MixSpotCrossHistoryEntrustsState = atom<
  SpotCrossHistoryEntrusts[]
>({
  key: "mix-spot-cross-history-entrusts-state",
  default: [],
});

/**
 * spotIsolateHistoryEntrusts 信息  updateSpotIsolateHistoryEntrustsList
 */
export const MixSpotIsolateHistoryEntrustsState = atom({
  key: "mix-spot-isolate-history-entrusts-state",
  default: [],
});

/**
 * spotCrossUserAccountDeal 全仓成交明细
 */
export const MixSpotCrossUserAccountDealState = atom<SpotDealtRecord[]>({
  key: "mix-spot-cross-user-account-deal-state",
  default: [],
});

/**
 * spotIsolateUserAccountDeal 逐仓成交明细
 */
export const MixSpotIsolatedUserAccountDealState = atom<SpotDealtRecord[]>({
  key: "mix-spot-isolated-user-account-deal-state",
  default: [],
});

/**
 * spotIndexPrices 信息
 */
export const MixSpotIndexPricesState = atom({
  key: "mix-spot-index-prices-state",
  default: [],
});

/**
 * isolateLevelInfo 信息   废弃无用
 */
export const MixSpotIsolatedLevelInfoState = atom({
  key: "mix-spot-isolate-lvel-info-state",
  default: [],
});

/**
 * crossLevelInfo 信息   只有计算器在用了
 */
export const MixSpotCrossLevelInfoState = atom({
  key: "mix-spot-cross-level-info-state",
  default: [],
});

/**
 * currentOCOEntrust 信息  currentMarginOCOEntrust
 */
export const MixSpotCurrentOCOEntrustState = atom({
  key: "mix-spot-current-oco-entrust-state",
  default: [],
});
/**
 * currenttanceEntrust
 */
export const MixSpotCurrentTraceEntrustState = atom({
  key: "mix-spot-current-trace-entrust-state",
  default: [],
});

/**
 * currentOCOEntrust 信息
 */
export const MixSpotCurrentCrossOCOEntrustState = atom({
  key: "mix-spot-current-cross-oco-entrust-state",
  default: [],
});

/**
 * currentOCOEntrust 信息
 */
export const MixSpotCurrentIsolatedOCOEntrustState = atom({
  key: "mix-spot-current-isolatedoco-entrust-state",
  default: [],
});

/**
 * currentOCOEntrust 当前币对 信息 普通 杠杆（全.逐）
 */
export const MixSpotCurrentOCOEntrustSymbolSwitch = atom({
  key: "mix-spot-current-oco-entrust-selector-symbol-switch",
  default: [],
});

/**
 * currentTraceEntrust 当前币对 信息 现货
 */
export const MixSpotCurrentTraceEntrustSymbolSwitch = atom({
  key: "mix-spot-current-trace-entrust-selector-symbol-switch",
  default: [],
});
/**
 * historyTraceEntrust 当前币对 信息 现货
 */
export const MixSpotHistoryTraceEntrustSymbolSwitch = atom({
  key: "mix-spot-history-trace-entrust-selector-symbol-switch",
  default: [],
});
/**
 * currentOCOEntrust Selector 信息 普通 杠杆（全.逐）
 */
export const MixSpotCurrentOCOEntrustSelector = selector({
  key: "mix-spot-current-oco-entrust-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    if (tabType === "spot") return get(MixSpotCurrentOCOEntrustState);
    if (tabType === "cross") return get(MixSpotCurrentCrossOCOEntrustState);
    if (tabType === "isolated")
      return get(MixSpotCurrentIsolatedOCOEntrustState);
    return [];
  },
});

/**
 * coinSlippage 滑点信息
 */
// export const MixSpotCoinSlippageState = atom({
//     key: 'mix-spot-coin-slippage--state',
//     default: []
// })

/**
 * 获取指定symbolId、symbolCode的币对信息
 */
export const MixSpotAllContractListSelector = selector({
  key: "mix-spot-all-ct-list-selector",
  get: ({ get }) => {
    const allSpotContractList = get(MixSpotConfigListState);
    return (symbolId, symbolCode) => {
      if (allSpotContractList && allSpotContractList.length) {
        return (
          allSpotContractList.find(
            (item) =>
              item.symbolId === symbolId || item.symbolCode === symbolCode
          ) || createDefaultSpotConfig()
        );
      }
      return createDefaultSpotConfig();
    };
  },
});

/**
 * 现货列表接口state
 */
export const MixSpotAllSymbolState = atom({
  key: "mix-spot-all-symbol-state",
  default: [],
});

// 币币列表接口   只价格提醒在用
// 路由入口用下 rexzhao
export const MixSpotConfigListSelector = selector({
  key: "mix-spot-config-list",
  get: async ({ get }) => {
    try {
      // 英国合规需要locale 参数
      const locale = get(LocaleState);
      const res = await spotAllSymbol({ locale });
      if (isSuccess(res?.code)) {
        const items = res?.data?.items || [];
        const spotList = items[0]?.symbolDTOList || [];
        return spotList;
      }
      return [];
    } catch (error) {
      console.log("error: ", error);
      return [];
    }
  },
});

// 获取vip 详情 信息
export interface IMixSpotVipDetailState {
  platsk: {
    platskBalance: string;
    discount: string;
  };
  ct: {
    maker: string;
    originalMaker: string;
    originalTaker: string;
    taker: string;
  };
  spot: {
    maker: string;
    originalMaker: string;
    originalTaker: string;
    taker: string;
  };
  margin: {
    maker: string;
    originalMaker: string;
    originalTaker: string;
    taker: string;
  };
  vipLevel: number;
  vipLevelDesc: string;
  isLoading?: boolean;
}

export const creatMixSpotVipDetailState = () => {
  return {
    platsk: {
      platskBalance: "",
      discount: "",
    },
    ct: {
      maker: "",
      originalMaker: "",
      originalTaker: "",
      taker: "",
    },
    spot: {
      maker: "",
      originalMaker: "",
      originalTaker: "",
      taker: "",
    },
    margin: {
      maker: "",
      originalMaker: "",
      originalTaker: "",
      taker: "",
    },
    vipLevel: 0,
    vipLevelDesc: "",
    isLoading: true,
  };
};
export const MixSpotVipDetailState = atom<IMixSpotVipDetailState>({
  key: "mix-spot-vip-detail-state-atom",
  default: {
    ...creatMixSpotVipDetailState(),
  },
});

// isOpenSpotLever 杠杆开放状态接口
interface IMixSpotIsOpenSpotLeverState {
  isOpen: boolean | string;
  bCoefficient: string;
  qCoefficient: string;
}

export const MixSpotIsOpenSpotLeverState = atom<IMixSpotIsOpenSpotLeverState>({
  key: "mix-spot-is-open-spot-lever-state-atom",
  default: {
    isOpen: "",
    bCoefficient: "", // 全仓 白名单系数
    qCoefficient: "", // 逐仓 白名单系数
  },
});

export const MixSpotLanguageWhiteListState = selector({
  key: "mix-spot-language-white-list",
  get: async () => {
    // 应后台要求  去掉了白名单   如有问题请联系 faker 张
    return {
      languageWhiteList: [],
      openLanguageWhiteList: false,
    };
    // const res: any = await getLanguageWhiteList()
    // if (isSuccess(res.code) && res.data) {
    //     return res.data
    // } else {
    //     throw res.msg
    // }
  },
});

export const MixSpotLanguageWhiteListStatus = selector({
  key: "mix-spot-language-white-list-status",
  get: ({ get }) => {
    const locale = get(LocaleSelector);
    const res = get(MixSpotLanguageWhiteListState);
    if (!res.openLanguageWhiteList) return true;
    let tmpLangTypeObj = supportLanguageList.find(
      (item) => item.locale === locale
    );
    let find = false;
    if (tmpLangTypeObj) {
      find = res.languageWhiteList.find(
        (item) => tmpLangTypeObj.languageType === item.code
      );
    }
    // return true
    return !!find;
  },
});

//selector
// spotTicker 获取当前的ticker
export const MixSpotConfigTickerSelector = selector<SpotTicker>({
  key: "mix-spot-config-ticer-selector",
  get: ({ get }) => {
    const tickerHttp = queryClient.getQueryData<SpotTicker>(
      spotTickerQuery.queryKey
    );
    const spotConfig = get(MixSpotConfigState);
    const allTicker = get(MixSpotAllTickerState);
    const preferenceSetting = get(UserPreferenceSettingState);
    const timezone = preferenceSetting.timezone;

    let spotTicker = allTicker.find(
      (ticker) => ticker.symbolCode === spotConfig.symbolCode
    );
    let spotQueryTicker = tickerHttp?.[0] ?? {};
    if (spotTicker) {
      spotTicker = {
        ...spotTicker,
        chgUTC: timezone === 0 ? spotTicker.chgUTC : spotTicker.change,
      };
    }
    return spotTicker || spotQueryTicker || createDefaultSpotTicker();
  },
});

// platsk抵扣 开关  这里可以暂时不用  换成 const [userInfo, setUserInfo] = useRecoilState(UserState) userInfo.openGtFees
export const MixSpotOpenGtFeesState = atom<boolean>({
  key: "mix-spot-open-Gt-fees-state",
  default: true,
});

// platsk抵扣费率
export const MixSpotDuctionFeeRadioRateState = atom<string>({
  key: "mix-spot-duction-fee-radio-rate-state",
  default: "",
});

// 杠杆 全逐仓 新手提示 步数状态
// 一共4步
// 默认5  代表已经提示过了，不用再提示
// 如果没提示过，ls 的 spot_lever_guide_step 为0，
// 如果提示过，  ls 的 spot_lever_guide_step 为1
export const MixSpotMarginGuideStepState = atom<number>({
  key: "mix-spot-margin-guide-step-state",
  default: 5,
});

// 风险率
export const MixSpotRiskRateSeleter = selector<number>({
  key: "mix-spot-risk-rate-selector",
  get: ({ get }) => {
    const tabType = get(MixSpotTabTypeState);
    const crossAccounts = get(MixSpotCrossAccountsState);
    const isolatedAccounts = get(MixSpotIsolatedAccountsState);
    const indexPrices = get(MixSpotIndexPricesState);
    const marginRiskRatioCoin = get(MixMarginRiskRatioCoinListState);
    const { baseSymbol, symbolCode } = get(MixSpotConfigState);
    let riskRate = 0;
    if (tabType === "spot") return riskRate;
    riskRate = getRiskRate(
      tabType,
      baseSymbol,
      symbolCode,
      tabType === "cross" ? crossAccounts : isolatedAccounts,
      indexPrices,
      marginRiskRatioCoin
    );
    return riskRate;
  },
});

//获取当前价
export const MixSpotCurrentPrice = selector<string>({
  key: "mix-spot-current-price-selector",
  get: ({ get }) => {
    const spotTicker = get(MixSpotConfigTickerSelector);
    // return Number(spotTicker.status) === 1 ? spotTicker.op : spotTicker.price
    // modified by Calvin 2024 02 22 根据最新需求，不在向用户展示开盘价
    return spotTicker.price;
  },
});
//

//获取当前交易对自己的买卖深度价格列表
export const MixSpotDepthPriceList = selector({
  key: "mix-spot-depth-price-list-selector",
  get: ({ get }) => {
    let list = get(MixSpotCurrentEntrustState);
    let tempBuyArray = [];
    let tempSellArray = [];
    // 要去区分买卖深度价格数组t

    for (let entrust of list) {
      if (entrust.ftype === 0) {
        tempBuyArray.push(entrust.fprize);
      }
      if (entrust.ftype === 1) {
        tempSellArray.push(entrust.fprize);
      }
    }
    return { buy: tempBuyArray, sell: tempSellArray };
  },
});

/**
 *  maker taker 当前switch state 信息
 */
export const MixSpotHeaderLazySwitchState = atom<boolean>({
  key: "mix-spot-header-lazy-switch-state",
  default: false,
});

/**
 *  maker taker 当前开关状态 state 信息
 */
export const MixSpotHeaderLazyShowState = atom<boolean>({
  key: "mix-spot-header-lazy-show-state",
  default: false,
});

/**
 * setAllCoinConfigList 配置信息
 *
 */
export const MixSpotAllCoinConfigInfoState = atom<[]>({
  key: "mix-spot-all-coin-config-info-state",
  default: [],
});

/**
 *
 *
 */
export const MixSpotAllCoinConfigInfoSelector = selector({
  key: "mix-spot-all-coin-config-info",
  get: ({ get }) => {
    const toggle = get(MixSpotAllCoinConfigInfoState);
    return toggle;
  },
  set: ({ set }, data: Array<any>) => {
    let newdata = data.map((item) => {
      let chainCoinId = 0;
      let chainCoinName = null;
      let rechargeable = false;
      let withdrawable = false;
      if (
        item.spotCoinChainResultList &&
        item.spotCoinChainResultList.length > 0
      ) {
        let result = item.spotCoinChainResultList[0];
        chainCoinId = result.chainCoinId;
        chainCoinName = result.chainCoinName;
        rechargeable = item.spotCoinChainResultList.some(
          (i) => !!i.rechargeable
        );
        withdrawable = item.spotCoinChainResultList.some(
          (i) => !!i.withdrawable
        );
      }
      return {
        ...item,
        chainCoinId,
        chainCoinName,
        rechargeable,
        withdrawable,
      };
    });
    set(MixSpotAllCoinConfigInfoState, newdata);
  },
});

// totalBlansDebt 信息 获取 全仓 || 逐仓  总资产  总负债   暂无使用
export const MixSpotTotalBlansDebtSelector = selector({
  key: "mix-spot-total-blans-debt-selector",
  get: ({ get }) => {
    const spotConfig = get(MixSpotConfigState);
    const tabType = get(MixSpotTabTypeState);
    const crossAccounts = get(MixSpotCrossAccountsState);
    const isolatedAccounts = get(MixSpotIsolatedAccountsState);
    const spotIndexPrices = get(MixSpotIndexPricesState);
    let rightCoinPrecision = spotConfig?.placeConfig?.quotePrecision || 5; // 右币精度
    let rd = Decimal.ROUND_DOWN;

    let computedCoin = "USDT"; // 以usdt计算 也就是 换算成usdt价值
    let totalBlans = new Decimal(0); // 资产
    let totalDebt = new Decimal(0); // 负债

    // 全、逐仓 资产列表
    let accountsTmp = isolatedAccounts;
    if (tabType === "cross") {
      accountsTmp = crossAccounts;
    }

    // 没有资产 没有指数价格  返回 0 即可
    if (!accountsTmp.length || !spotIndexPrices.length) {
      return {
        computedCoin,
        totalBlans: totalBlans.toFixed(rightCoinPrecision, rd),
        totalDebt: totalDebt.toFixed(rightCoinPrecision, rd),
      };
    }

    let infoObj = {};

    accountsTmp.forEach((element) => {
      // 当前币 资产 负债数量
      let blansNum = new Decimal(0)
        .add(element.free || 0)
        .add(element.locked || 0);
      let debtNum = new Decimal(0)
        .add(element.borrowed || 0)
        .add(element.interest || 0);

      // 当前币对应指数价格
      let iprice = spotIndexPrices.find(
        (ipItem) => ipItem.baseSymbol === element.tokenId
      );
      if (element.tokenId === computedCoin) {
        iprice = {
          tickerPrice: 1,
        };
      }
      if (!iprice) {
        iprice = {
          tickerPrice: 0,
        };
        console.warn(notFindIndexPriceItemErrorText, element.tokenId);
      }

      let curBlans = blansNum.times(iprice.tickerPrice || 0);
      let curDebt = debtNum.times(iprice.tickerPrice || 0);

      // 总资产字段 + 当前币 资产
      totalBlans = totalBlans.add(curBlans);
      totalDebt = totalDebt.add(curDebt);

      // 调式信息
      infoObj = {
        ...infoObj,
        [element.tokenId]: {
          free: element.free,
          locked: element.locked,
          borrowed: element.borrowed,
          interest: element.interest,

          indexPrice: iprice.tickerPrice,
          curBlans: curBlans.toString(),
          curDebt: curDebt.toString(),
        },
      };
    });
    // console.log('获取 infoObj,', infoObj)
    return {
      infoObj,
      computedCoin,
      totalBlans: new Decimal(totalBlans).toFixed(rightCoinPrecision, rd),
      totalDebt: new Decimal(totalDebt).toFixed(rightCoinPrecision, rd),
    };
  },
});

// 现货委托单类型
export const DelegateType = {
  delegate_limit: "delegate_limit",
  delegate_market: "delegate_market",
  delegate_plan: "delegate_plan",
  delegate_oco: "delegate_oco",
  delegate_tpsl: "delegate_tpsl",
  delegate_track: "delegate_track",
};
// oco，计划委托，止盈止损，追踪委托tips
export const DelegateTips = {
  delegate_oco: "oco_module_new.tab_hover_tips",
  delegate_plan: "trade_spot.plan_entrust_tips",
  delegate_tpsl: "spot_margin_tpsl.form.tpsl_tips",
  delegate_track: "track_entrust.tooltip",
};
export type DelegateValueType =
  | typeof DelegateType.delegate_limit
  | typeof DelegateType.delegate_market
  | typeof DelegateType.delegate_plan
  | typeof DelegateType.delegate_oco
  | typeof DelegateType.delegate_tpsl;

/**
 * 现货委托单全局状态
 */
export const SpotDeleagateTypeState = atom({
  key: "spot-delegate-type-state",
  default: DelegateType.delegate_limit,
});

/**
 * symbolSwitch 信息 记录是否只展示当前币对
 */
export const MixSpotSymbolSwitchState = atom<boolean>({
  key: "mix-spot-symbol-switch-state",
  default: false,
});

/**
 * 信息 获取指定symbolId的 币对信息
 */
export const MixSpotGrabSymbolInfoSelector = selector({
  key: "mix-spot-grab-symbol-info-selector",
  get: ({ get }) => {
    let configList = get(MixSpotConfigListState);
    return (
      symbolId: string // 需要扣掉的手续费
    ) => {
      return (
        configList.find((config) => config.symbolId === symbolId) ||
        createDefaultSpotConfig()
      );
    };
  },
});

//selector
// spotTicker 获取指定symbolId的ticker 已方便获取价格
export const MixSpotConfigTickerBySymbolIdSelector = selector({
  key: "mix-spot-config-ticer-by-symbolid-selector",
  get: ({ get }) => {
    const allTicker = get(MixSpotAllTickerState);
    const preferenceSetting = get(UserPreferenceSettingState);
    const timezone = preferenceSetting.timezone;
    let configList = get(MixSpotConfigListState);
    return (symbolId: string) => {
      let sconfig =
        configList.find((config) => config.symbolId === symbolId) ||
        createDefaultSpotConfig();
      let spotTicker = allTicker.find(
        (ticker) =>
          ticker.baseSymbol.toUpperCase() ===
            sconfig.baseSymbol.toUpperCase() &&
          ticker.pricedSymbol.toUpperCase() ===
            sconfig.pricedSymbol.toUpperCase()
      );
      if (spotTicker) {
        spotTicker = {
          ...spotTicker,
          chgUTC: timezone === 0 ? spotTicker.chgUTC : spotTicker.change,
        };
      }
      return spotTicker || createDefaultSpotTicker();
    };
  },
});

// 无奈 input值需要存 recoil    全仓
// 全仓 限价
export const crossLimitFormPriceState = atom({
  key: "spot-cross-limit-form-price-state",
  default: "",
});

/**
 *  委托列表中选中的tab 委托类型 normal plan oco
 */
export const MixSpotTableTypeState = atom<string>({
  key: "mix-spot-table-type-state",
  default: "normal",
});

// h5 左右布局   下单这块
// 需要计算 总资产  总负债   暂无使用
export const MixSpotgetTotalBlansDebtSelector = selector({
  key: "mix-spot-get-total-Blans-debt-selector",
  get: ({ get }) => {
    const spotConfig = get(MixSpotConfigState);
    const tabType = get(MixSpotTabTypeState);
    const spotIsolateAccounts = get(MixSpotIsolatedAccountsState);
    const spotIndexPrices = get(MixSpotIndexPricesState);
    const spotCrossAccounts = get(MixSpotCrossAccountsState);

    let rightCoinPrecision = spotConfig?.placeConfig?.quotePrecision || 5; // 右币精度
    // let leftCoinPrecision = spotConfig?.placeConfig?.volumePlace || 5 // 左币精度
    let rd = Decimal.ROUND_DOWN;

    let computedCoin = "USDT"; // 以usdt计算 也就是 换算成usdt价值
    let totalBlans = new Decimal(0); // 资产
    let totalDebt = new Decimal(0); // 负债

    // 全、逐仓 资产列表
    let accountsTmp = spotIsolateAccounts;
    if (tabType === "cross") {
      accountsTmp = spotCrossAccounts;
    }

    // 没有资产 没有指数价格  返回 0 即可
    if (!accountsTmp.length || !spotIndexPrices.length) {
      return {
        computedCoin,
        totalBlans: totalBlans.toFixed(rightCoinPrecision, rd),
        totalDebt: totalDebt.toFixed(rightCoinPrecision, rd),
      };
    }

    let infoObj = {};

    accountsTmp.forEach((element) => {
      // 当前币 资产 负债数量
      let blansNum = new Decimal(0)
        .add(element.free || 0)
        .add(element.locked || 0);
      let debtNum = new Decimal(0)
        .add(element.borrowed || 0)
        .add(element.interest || 0);

      // 当前币对应指数价格
      let iprice = spotIndexPrices.find(
        (ipItem) => ipItem.baseSymbol === element.tokenId
      );
      if (element.tokenId === computedCoin) {
        iprice = {
          tickerPrice: 1,
        };
      }

      if (!iprice) {
        iprice = {
          tickerPrice: 0,
        };
        console.warn(notFindIndexPriceItemErrorText, element.tokenId);
      }

      let curBlans = blansNum.times(iprice.tickerPrice || 0);
      let curDebt = debtNum.times(iprice.tickerPrice || 0);

      // 总资产字段 + 当前币 资产
      totalBlans = totalBlans.add(curBlans);
      totalDebt = totalDebt.add(curDebt);

      // 调式信息
      infoObj = {
        ...infoObj,
        [element.tokenId]: {
          free: element.free,
          locked: element.locked,
          borrowed: element.borrowed,
          interest: element.interest,

          indexPrice: iprice.tickerPrice,
          curBlans: curBlans.toString(),
          curDebt: curDebt.toString(),
        },
      };
    });
    // console.log('获取 infoObj,', infoObj)
    return {
      infoObj,
      computedCoin,
      totalBlans: new Decimal(totalBlans).toFixed(rightCoinPrecision, rd),
      totalDebt: new Decimal(totalDebt).toFixed(rightCoinPrecision, rd),
    };
  },
});

// 我的带单/跟单数据
export const MixSpotAllTradeOrderState = atom({
  key: "mix-spot-all-trade-order-state",
  default: [],
});

/**
 * 处理 allTraceOrders 并返回新数据
 */
export const MixSpotAllTradeOrderSelector = selector({
  key: "mix-spot-all-trade-order-selector",
  get: ({ get }) => {
    const allTraceOrders = get(MixSpotAllTraceOrdersState) || [];
    const allTicker = get(MixSpotAllTickerState) || [];
    const getSpotContractInfo = get(MixSpotGrabSymbolInfoSelector);

    const allCoinConfigList = get(MixSpotAllCoinConfigInfoState);
    // 获取币种图标
    const getCoinIconBySymbol = (symbolCode) => {
      const coin: any = allCoinConfigList.find((item: any) => {
        if (symbolCode === "LUNA2") {
          return item.coinName === "LUNA";
        }
        return item.coinName === symbolCode; // 测试环境的 symbol 很奇怪啊，栗子：BNB 的是 b ，ETH的是 e ???
      });
      if (coin) {
        return coin.imgUrl;
      }
      return null;
    };
    if (allTraceOrders && allTraceOrders.length) {
      return allTraceOrders.map((item) => {
        const itemObj = { ...item };
        // 币对的配置信息
        const productInfo = getSpotContractInfo(itemObj.symbolId);
        itemObj.delegatePricePlace =
          productInfo?.placeConfig?.delegatePricePlace || 1; // 价格精度
        itemObj.priceEndStep = productInfo?.placeConfig?.priceEndStep || 1; // 价格精度

        itemObj.dealCount = itemObj?.dealCount || itemObj.buyDealCount; //成交数量

        itemObj.baseSymbol = productInfo.baseSymbol; //左币
        itemObj.imgUrl = getCoinIconBySymbol(itemObj.baseSymbol); //左币图标

        itemObj.pricedSymbol = productInfo?.pricedSymbol; //右币
        itemObj.quotePrecision = productInfo?.placeConfig?.quotePrecision || 6; //收益率精度
        itemObj.pricePlace = productInfo?.placeConfig?.pricePlace || 4; // 价格精度

        const priceObj = allTicker.find(
          (d) =>
            itemObj.baseSymbol.toLowerCase() === d.baseSymbol.toLowerCase() &&
            itemObj.pricedSymbol.toLowerCase() === d.pricedSymbol.toLowerCase()
        ); //获取 当前币对推送数据
        itemObj.marketPrice = priceObj?.price || 1; //当前价

        // 明细
        itemObj.dealCountTotal = itemObj.holdCount;
        const cost = onCost(itemObj.buyDelegateCount, itemObj.buyPrice);
        const amount = onAmount(itemObj.marketPrice, itemObj.dealCount);

        let decimalProfits = Object.assign(
          {},
          onRoe(cost, amount, itemObj.quotePrecision)
        );

        // 汇总

        return { ...itemObj, ...decimalProfits };
      });
    }
    return [];
  },
  set: ({ set }, params: any) => {
    const listData = params.listData || [];
    // 明细
    if (params.tabType === SPOT_TACE_TAB.DETAIL_TYPE) {
      listData.map((item: any) => {
        let itemObj = {
          ...item,
          dealCountTotal: "",
        };
        itemObj.dealCountTotal = itemObj.holdCount;

        let cost = onCost(itemObj.buyDelegateCount, itemObj.buyPrice);
        let amount = onAmount(itemObj.marketPrice, itemObj.dealCount);

        let decimalProfits = Object.assign(
          {},
          onRoe(cost, amount, itemObj.quotePrecision)
        );

        return { ...itemObj, ...decimalProfits };
      });
      set(MixSpotAllTradeOrderState, listData);
    } else if (params.tabType === SPOT_TACE_TAB.SUMMARY_TYPE) {
      // 汇总
      const result = [];
      listData.forEach((item) => {
        if (result[item.symbolId + "_" + item.symbolDisplayName]) {
          result[item.symbolId + "_" + item.symbolDisplayName].push(item);
        } else {
          result[item.symbolId + "_" + item.symbolDisplayName] = [item];
        }
      });

      const summaryList = [];
      Object.values(result).forEach((symbolId) => {
        summaryList.push(summaryCalMix(symbolId));
      });
      set(MixSpotAllTradeOrderState, summaryList);
    }
  },
});

export interface IMixSpotFlutterPointState {
  commonRate: string;
  symbolRateMap: object;
}

/**
 * 现货滑点比例
 */
export const MixSpotFlutterPoint = atom<IMixSpotFlutterPointState>({
  key: "mix-spot-flutter-point-state",
  default: null,
});

/**
 * MixSpotTokenClassificationState 记录当前币对列表带有观察标签的信息
 */
export const MixSpotTokenClassificationState = atom({
  key: "mix-spot-token-classification-state",
  default: {},
});
